<template>
  <li
    class="grid grid-cols-[auto_1fr_auto] items-center gap-x-3 gap-y-1 mb-2.5"
  >
    <div
      class="h-[70px] aspect-[16/9] row-span-2 rounded overflow-hidden flex justify-center"
    >
      <BaseImg :media="props.game.coverMedia" ratio="16/9" alt="" />
    </div>
    <h4 class="font-bold text-base">{{ game.name }}</h4>

    <div class="flex flex-col items-center justify-center row-span-2 gap-1">
      <button
        v-if="mode === 'play'"
        class="btn btn-primary btn-xs rounded"
        @click="clickPlay(game.uuid!)"
      >
        {{ $t("Buttons.view") }}
      </button>
      <template v-else-if="mode === 'edit'">
        <template v-if="game.status === 2">
          <button class="btn btn-xs rounded" @click="clickEdit(game)">
            {{ $t("Buttons.edit") }}
          </button>
          <button class="btn btn-xs rounded" @click="clickDelete(game.id!)">
            {{ $t("Buttons.delete") }}
          </button>
        </template>
        <template v-else-if="game.status === 1">
          <button class="btn btn-xs rounded" @click="clickEdit(game)">
            {{ $t("Buttons.update") }}
          </button>
          <button
            class="btn btn-primary btn-xs rounded"
            @click="clickPlay(game.uuid!)"
          >
            {{ $t("Buttons.view") }}
          </button>
        </template>
      </template>
      <button
        v-else-if="mode === 'continue'"
        class="btn btn-primary btn-xs rounded"
      >
        {{ $t("Buttons.continue") }}
      </button>
      <button v-else-if="mode === 'review'" class="btn btn-xs rounded">
        {{ $t("Buttons.review") }}
      </button>
    </div>
    <VanTextEllipsis
      :content="game.description"
      class="leading-4 break-all text-base-content/50"
      rows="3"
    />
  </li>
</template>

<script lang="ts" setup>
import { useGalGameEditor } from "@/stores/galGameEditor";
import { useGalGameHome } from "@/stores/galGameHome";
import { useAvatarImg, useDefaultAvatar } from "@/use/common";
import { showConfirmDialog } from "vant";
import { PropType, computed } from "vue";
import i18n from "@/locales";
import { useRouter } from "vue-router";

const store = useGalGameHome();
const router = useRouter();

const props = defineProps({
  // Your props go here
  mode: {
    type: String,
    default: "play", // play, edit, continue, review, publish
  },
  game: {
    type: Object as PropType<GalGame>,
    default: () => ({}),
  },
});

const clickDelete = async (id: number) => {
  showConfirmDialog({
    title: i18n.global.t("ConfirmModal.promptTitle"),
    message: i18n.global.t("ConfirmModal.sureDeleteText"),
    confirmButtonText: i18n.global.t("Buttons.confirm"),
    cancelButtonText: i18n.global.t("Buttons.cancel"),
  })
    .then(async () => {
      store.deleteGame(id);
    })
    .catch(() => {});
};

const clickEdit = async (item: GalGame) => {
  useGalGameEditor().resetGame(item);
  router.push({
    name: "galGameEditor",
    params: { uuid: item.uuid },
  });
};

const clickPlay = (uuid: string) => {
  router.push({
    name: "galGameDetail",
    params: { uuid },
  });
};
</script>

<style scoped>
/* Your component styles go here */
</style>
